import AI_SUGGESTION_TYPES from './aiSuggestionTypes';

/**
 * ### AI_LOGISTICS_SUGGESTIONS
 *
 * @description
 * Predefined suggestions for logistics (shipping) questions in project setup
 * These are used by the AI agent to create suggestions
 */
export default {
  type: AI_SUGGESTION_TYPES.PROMPT,
  choices: [
    {
      label: 'I want Highlight to manage shipping',
      value:
        'Ship your product(s) to us and Highlight will handle all the details to get things packed and shipped to participants',
      prompt:
        "The user wants Highlight to manage shipping. Set logisticType to ['highlight_managed'] and call updateProjectRequirements",
    },
    {
      label: 'I will manage shipping',
      value:
        'You will fully own preparing and shipping products to participants; this can be combined with on-site pickup.',
      prompt:
        "The user will manage shipping themselves. Set logisticType to ['customer_managed'] and call updateProjectRequirements",
    },
    {
      label: 'Participants to pickup on-site',
      value:
        'Participants can pick up products at your location; this can be combined with self-managed shipping.',
      prompt:
        "The user wants no delivery — participants will pick up products on-site. Set logisticType to ['onsite_pickup'] and call updateProjectRequirements",
    },
  ],
} as const;
